<template>
<!-- 可点击遮罩层@click.prevent.self="$emit('input', false)"  -->
<div class="address_model" :class="value && 'open'" @click.prevent.self="$emit('input', false)">
	<transition name="model"  @after-leave="$emit('close')">
		<div v-if="value" class="model">
			<!-- <button @click="$emit('input', false)" class="close"/> -->

			<!-- <div class="content">
				
			</div> -->
			<slot/>
		</div>
	</transition>
</div>
</template>

<script>
export default {
	props: {
		value: {
			value: Boolean,
			default: false
		},
		data: {
			value: String,
		},
	},
}
</script>

<style lang="less" scoped>
.address_model {
	width: 100%;
	height: 100%;
	position: fixed;
	z-index: 10000;
	pointer-events: none;
	transition: all .3s;
	top: 0;
	right: 0;
	bottom: 0;
	font-size: 30px;

	display: flex;
	justify-content: center;
	align-items: center;
	&.open {
		background-color: #24283e88;
		
		pointer-events: auto;
	}


	// .radio_ui();

	.model {
		position: relative;
		border-radius: 8px;
		bottom: 0;
		transition: all .3s ;
		transition-timing-function: cubic-bezier(0.18, 0.72, 0.32, 1.28);

		&.model-enter, &.model-leave-to {
			transform: scale(0);
			opacity: 0;
		}
		&.model-enter-to, &.model-leave {
			opacity: 1;
			transform: scale(1);
		}
	}
}
</style>